import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'portal-ui-session-expired',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './session-expired.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SessionExpiredComponent {}
